import { DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION /*, FLAGSMITH_FEATURES */ } from '../constants'
// import useFlagsmithFeature from './useFlagsmithFeature'

const useInstrumentUnificationFeature = ({ study = {}, userId }) => {
  const { config, id: studyID } = study
  const instrumentArchitectureVersion =
    config?.instrument_architecture_version || DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION

  // const flagsmithFeatures = useFlagsmithFeature({
  //   /**
  //    * For the featureFlags key, we put in a object for what the default value of
  //    * the feature flag(s) should be in case there is an error with the Flagsmith API.
  //    */
  //   featureFlags: { [FLAGSMITH_FEATURES.instrumentUnification]: { enabled: true } },
  //   userId,
  //   studyId: studyID,
  // })

  // We will show Instrument Unification UI only when ALL of these conditions are met
  // - `instrument_architecture_version` > 1
  // - Study config contains `unification` field with value equals to `{}`
  const hasInstrumentUnification =
    !!config?.unification && instrumentArchitectureVersion > DEFAULT_INSTRUMENT_ARCHITECTURE_VERSION // && flagsmithFeatures[FLAGSMITH_FEATURES.instrumentUnification]?.enabled

  return {
    hasInstrumentUnification,
  }
}

export default useInstrumentUnificationFeature
